<template lang="pug">
  .component-kepler-file-upload
    .preview(v-if="previewUrl")
      .preview-image(v-if="canPreview", :style="previewStyle")
      .download-file(v-else)
        a(@click="openUrl")
          i.fa.fa-file-pdf-o.fa-3x
          br
          small {{previewUrl}}
      button.button.alert.small(@click="$emit('sel', null)", v-if="!previewOnly") Remove
    .uploader(v-if="!previewOnly")
      .input-group
        input.input-group-field(type='file', ref="file")
        .input-group-button
          input.button(type='submit', @click="startUpload", value="Upload")

      button.button.small(@click="advanced = !advanced") ADVANCED

    .advanced-upload(v-if="advanced")
      label VISIBILITY
        select(v-model="visibility")
          option(v-for="o in visibilityOptions") {{ o }}

      label PREFIX
        select(v-model="prefix")
          option(value="null", selected) no_prefix
          option(v-for="o in prefixOptions") {{ o }}

      label FILENAME
        input(type="text", v-model="filename", placeholder="filename")


      .square(v-if="response")
        img(:src="response.external_url")

      .uploaded-gallery
        .square(v-for="l in listing")
          .delete(@click="deleteFile(l.internal_path)")
            .fa.fa-times
          img(v-if="preview(l.internal_path)", :src="l.external_url", @click="imageSelected(l)", :alt="l.internal_path")
          .other-file(v-else, @click="imageSelected(l)")
            i.fa.fa-file-pdf-o.fa-3x
            small.internal-path {{l.internal_path}}

</template>


<script>


  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'KeplerFileUpload',
    data() {
      return {
        response: null,
        prefix: '',
        visibility: null,
        filename: null,
        listing: [],
        advanced: false,
      }
    },

    mounted() {
      if (this.selectedPrefix) {
        this.prefix = this.selectedPrefix
      }
      if (this.selectedVisibility) {
        this.visibility = this.selectedVisibility
      }
      var self = this

      KeplerBackofficeSdk.files.list.public(function (data) {
        self.listing = data
      })
    },

    methods: {
      startUpload() {
        var self = this

        var file = this.$refs.file.files[0]

        KeplerBackofficeSdk.files.uploadImage(file, self.visibility, self.prefix, self.filename, function (data) {
          self.response = data
          MaggieHelper.notification('upload', 'File uploaded successfully')

          self.$emit('sel', self.response.internal_path)
        })

      },
      imageSelected(l) {
        this.$emit('sel', l.internal_path)
        MaggieHelper.notification('upload', 'File selected successfully')

        this.advanced = false
      },
      deleteFile(internalPath) {
        this.$confirm('Are you sure?', 'Do you want to delete this file?', () => {
          KeplerBackofficeSdk.files.remove(internalPath)
          MaggieHelper.notification('Deleted', 'File deleted sucessfully')
          this.listing = null
          KeplerBackofficeSdk.files.list.public((data) => {
            this.listing = data
          })
        })
      },
      openUrl: function () {
        window.open(this.fileUrl, '_blank')
      },

      preview(url) {
        const extension = url.split('.')[1]
        switch (extension) {
          case 'pdf':
            return false
          default:
            return true
        }
      }
    },
    props: {
      visibilityOptions: {
        type: Array,
        default: function () {
          return [
            'public',
            'private'
          ]
        }
      },
      prefixOptions: {
        type: Array,
        default: function () {
          return [
            'vehicles',
            'vehicle-brands',
            'vehicle-categories',
            'parking-lot',
            'plans',
            'tocs',
            'vehicle-instructions',
            'damage-picture',
          ]
        }
      },
      selectedPrefix: {
        type: String
      },
      selectedVisibility: {
        type: String
      },
      previewUrl: {
        type: String
      },
      previewOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      canPreview() {
        if (this.previewUrl) {
          const extension = this.previewUrl.split('.')[1]
          switch (extension) {
            case 'pdf':
              return false
            default:
              return true
          }
        }

        return false
      },
      previewStyle() {
        return {
          backgroundImage: `url(${this.fileUrl})`,
          height: '200px',
          width: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center center',
        }
      },
      fileUrl() {
        return `${window.env.API_URL}/storage/${this.previewUrl}`
      },
    }
  }
</script>
<style lang="sass">
  .component-kepler-file-upload

    .uploader
      label
        display: block
        width: 140px

      input[type="text"], select
        width: 200px

    .preview

      margin: 10px 0
      text-align: center

      .button
        margin: 10px 0

    .advanced-upload
      .uploaded-gallery

        height: 300px
        width: 100%
        overflow: auto


        .delete
          text-align: right
          padding: 0 3px
          color: red
          z-index: 5
          position: absolute
          right: 0

        .internal-path
          word-break: break-word

        .square
          height: 110px
          width: 110px
          position: relative
          border: 1px black solid
          border-radius: 10px
          margin: 10px
          display: inline-block

          &:hover
            border: 3px black solid
            cursor: pointer

          img, .other-file
            text-align: center
            max-width: 100%
            max-height: 100%
            top: 50%
            position: absolute
            transform: translateY(-50%)
            overflow: hidden

</style>



// WEBPACK FOOTER //
// KeplerFileUpload.vue?36addeee